import styled from 'styled-components';
import { blueColor } from 'js/config/style';

export default styled.div.attrs({ className: 'details-link' })`
  color: ${blueColor};
  user-select: none;
  cursor: pointer;
  margin-top: 0.5rem;
  font-size: 0.9rem;
`;
